// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planned_work.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_type_time_slot } from "@buf/studyo_studyo-today-common.bufbuild_es/studyo/today/type/time_slot_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/planned_work.proto.
 */
export const file_studyo_today_planners_v1_resources_planned_work = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZWRfd29yay5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyKrAQoLUGxhbm5lZFdvcmsSCgoCaWQYASABKAkSLgoJdGltZV9zbG90GAIgASgLMhsuc3R1ZHlvLnRvZGF5LnR5cGUuVGltZVNsb3QSFwoPY3JlYXRvcl91c2VyX2lkGAMgASgJEjAKDGNyZWF0ZWRfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFQoNd29ya19zdGVwX2lkcxgFIAMoCUIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_timestamp, file_studyo_today_type_time_slot]);

/**
 * Describes the message studyo.today.planners.v1.resources.PlannedWork.
 * Use `create(PlannedWorkSchema)` to create a new message.
 */
export const PlannedWorkSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planned_work, 0);

